export enum FullyLoggedInStateType {
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    NO_FULLY_LOGGED_IN = 'FALSE'
}
